import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId, translate } from '../../../utility/functions';
import Table from '../../../table/Table';
import { useGlobalState } from '../../../stateProvider/StateProvider';

const AppRevenue = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
    } = useGlobalState();

    const tableConfig = {
        endpoint: QuestRoute.reports.mobile.revenue,
        disableMobileView: true,
        isReport: true,
        byLocation: true,
        colSpacing: [45],
        headers: [
            {
                label: 'Purchase Type',
                propKey: 'purchaseType',
                options: true,
            }, {
                label: 'Quantity',
                propKey: 'quantity',
                type: 'number'
            }, {
                label: 'Revenue',
                propKey: 'price',
                sortBy: true,
                ascending: false,
                type: 'number'
            },
        ],
        sticker: [
            {
                label: 'Total Revenue',
                color: '#21D59B',
                callback: (data) => formatCurrency(data.reduce((a, b) => b.price + a, 0))
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.purchaseType === 'AirPay' ? 'AirPAY' : e.purchaseType.replace(/([a-z])([A-Z])/g, '$1 $2')}</td>
                <td>{e.quantity}</td>
                <td>{formatCurrency(e.price)}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default AppRevenue;